import React, { useEffect } from "react";
import Table from "./Table";

const UjiSilangProvinsiSlideNegatif = () => {
  useEffect(() => {
    document.title = "SISMAL | Uji Silang Provinsi";
  }, []);

  return (
    <div className="dashboard-wrapper">
      <Table />
    </div>
  );
};

export default UjiSilangProvinsiSlideNegatif;
